import Swiper from 'swiper';
import { Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

export class CardProductGallery {
	constructor($container, options = {}) {
		this.$container = $container;
		this.options = options;

		this.init();
	}

	init() {
		const swiper = this.$container.querySelector('.js-card-product-gallery__swiper');
		const pagination = this.$container.querySelector('.js-card-product-gallery__pagination');
		if (!swiper || !pagination) return;

		this.productLink = this.$container.closest('.js-card-product')?.querySelector('.card-product__title a');

		this.swiper = new Swiper(swiper, {
			modules: [Pagination, EffectFade],
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 200,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: pagination,
				clickable: true,
			},
			on: {
				init: (swiper) => {
					swiper.pagination.el.addEventListener('mouseover', this.handlePaginationMouseOver);
				},
			},
		});

		this.bindProductLinkClick(pagination);
		this.bindProductLinkClick(this.swiper.slides);
	}

	bindProductLinkClick(targets) {
		if (!this.productLink) return;

		const elements = targets instanceof Element ? [targets] : [...targets];

		elements.forEach((element) => {
			element.addEventListener('mousedown', this.handleMiddleMouseDown);
			element.addEventListener('click', this.handleProductClick);
		});
	}

	handleMiddleMouseDown = (event) => {
		if (event.button !== 1) return;

		event.preventDefault();
		window.open(this.productLink.href, '_blank');
	};

	handleProductClick = (event) => {
		if (event.button !== 0) return;

		if (event.ctrlKey || event.metaKey) {
			window.open(this.productLink.href, '_blank');
			return;
		}

		window.location.assign(this.productLink.href);
	};

	handlePaginationMouseOver = (event) => {
		const target = event.target.closest('.swiper-pagination-bullet');
		if (!target) return;

		const index = this.swiper.pagination.bullets.indexOf(target);

		this.swiper.slideTo(index);
	};
}
